import React, { Fragment } from 'react';
import {Button} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useAppSelector} from "../../../hooks/hooks";
import { DartsGameType } from "../../../common/types/DartsGameTypes";
import { DARTS_SCORING, MATCH_STATS_TABLE, ACTIVE_GAME_SCORE, POST_MATCH, PRE_MATCH_STATS } from "../../../common/routes";

interface IDartsEventManagerActiveButtonsProps {
    gameId: number
    gameType: DartsGameType
}

const DartsEventManagerActiveButtons: React.FC<IDartsEventManagerActiveButtonsProps> = ({ gameId, gameType }) => {
    const pages = useAppSelector(state => state.Auth.pages);
    const navigate = useNavigate();
    const typeName = DartsGameType[gameType]?.toLowerCase() ?? "";

    const toScoring = () => {
        navigate(`${DARTS_SCORING}/${typeName}/${gameId}`);
    }

    const toScoreboardAndStats = () => {
        navigate(`${MATCH_STATS_TABLE}/${typeName}/${gameId}`);
    };

    const toActiveGameScore = () => {
        navigate(`${ACTIVE_GAME_SCORE}/${typeName}/${gameId}`);
    };

    const toPreMatchStats = () => {
        navigate(`${PRE_MATCH_STATS}/${typeName}/${gameId}`);
    };

    const toPostMatch = () => {
        navigate(`${POST_MATCH}/${typeName}/${gameId}`);
    };

    return (
        <Fragment>
            {pages['scoring'] &&
                <Button color="black" onClick={toScoring}>Scoring</Button>
            }
            {pages['scoreBoard'] &&
                <Button id="scoreboard" color="blue" onClick={toScoreboardAndStats}>Scoreboard & Stats</Button>
            }
            {pages['activeGame'] &&
                <Button id="active_score" color="violet" onClick={toActiveGameScore}>Active Game Score</Button>
            }
            {pages['preMatch'] &&
                <Button id="pre_match" color="purple" onClick={toPreMatchStats}>Pre-Match Image</Button>
            }
            {pages['post_match'] &&
                <Button id="scoreboard" color="facebook" onClick={toPostMatch}>Post-Match</Button>
            }
        </Fragment>
    );
};

export default DartsEventManagerActiveButtons;